import React, {FC, ReactNode} from 'react'

import cn from 'classnames/bind'

import Card from 'src/components/elements/Card'
import {TPriceColor} from 'src/types'

import s from './PricingCardWrapper.module.scss'
const cx = cn.bind(s)

interface IPricingCardWrapperProps {
	color: TPriceColor
	title: string
	children: ReactNode
	className?: string
}

const PricingCardWrapper: FC<IPricingCardWrapperProps> = ({color, title, children, className}) => {
	return (
		<Card className={cx('card', className)}>
			<header className={cx('card-header', color)}>{title}</header>
			{children}
		</Card>
	)
}

PricingCardWrapper.displayName = 'PricingCardWrapper'

export default PricingCardWrapper
